module.exports={
	"Form": "AccountTypeViewManifest",
	"Scope": "AccountType-View",
	"Descriptors":
	{
		"AccountTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "AccountType-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "AccountType-View-Identity",
				"Group": "AccountType-View-Identity"
			}
		},
		"AccountTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "AccountType-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "AccountType-View-Details",
				"Group": "AccountType-View-Details"
			}
		},
		"AccountTypeDetails.EntityName":
		{
			"Name": "Entity Name",
			"Hash": "AccountType-View-EntityName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "AccountType-View-Details",
				"Group": "AccountType-View-Details"
			}
		},
		"AccountTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "AccountType-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "AccountType-View-Details",
				"Group": "AccountType-View-Details"
			}
		},
		"AccountTypeDetails.IDAccountType":
		{
			"Name": "IDAccount Type",
			"Hash": "AccountType-View-IDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AccountType-View-DataAudit",
				"Group": "AccountType-View-DataAudit"
			}
		},
		"AccountTypeDetails.GUIDAccountType":
		{
			"Name": "GUIDAccount Type",
			"Hash": "AccountType-View-GUIDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AccountType-View-DataAudit",
				"Group": "AccountType-View-DataAudit"
			}
		},
		"AccountTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "AccountType-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AccountType-View-DataAudit",
				"Group": "AccountType-View-DataAudit"
			}
		},
		"AccountTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "AccountType-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "AccountType-View-DataAudit",
				"Group": "AccountType-View-DataAudit"
			}
		},
		"AccountTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "AccountType-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "AccountType-View-DataAudit",
				"Group": "AccountType-View-DataAudit"
			}
		},
		"AccountTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "AccountType-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "AccountType-View-DataAudit",
				"Group": "AccountType-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AccountType-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AccountType-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AccountType-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AccountType-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "AccountType-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "AccountType-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
